import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { SubpageHero } from '../components/SubpageHero';

export function NotFoundPage() {
  return (
    <>
      <SEO 
        title="Side ikke fundet (404)" 
        description="Siden du leder efter kunne ikke findes på Altmuligmanden Juelsminde." 
      />

      <SubpageHero
        badge="Fejl 404"
        title="Siden blev desværre ikke fundet"
        subtitle="Siden du leder efter er enten blevet flyttet, har skiftet adresse eller eksisterer ikke længere."
        icon="fa-solid fa-triangle-exclamation"
        breadcrumbs={[
          { label: "404 Fejl" }
        ]}
        showQuickContact={false}
      >
        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto bg-[#2193BB] hover:bg-[#1b7da0] text-white font-bold px-6 py-3 rounded-xl transition-all cursor-pointer flex items-center justify-center gap-2 shadow-md"
          >
            <i className="fa-solid fa-house" aria-hidden="true" />
            <span>Gå til Forsiden</span>
          </Link>

          <Link
            to="/ydelser"
            className="w-full sm:w-auto bg-[#1a2634] border border-[#9D9D9D]/30 hover:bg-[#223245] text-white font-bold px-6 py-3 rounded-xl transition-all cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-toolbox text-[#2193BB]" aria-hidden="true" />
            <span>Se alle ydelser</span>
          </Link>
        </div>
      </SubpageHero>
    </>
  );
}
